import { createFileRoute } from '@tanstack/react-router';
import { AgentsSection } from '@/features/settings/AgentsPages';

export const Route = createFileRoute('/app/settings/agents')({
  component: AgentsSection,
  staticData: { title: 'API keys and agents · Settings' },
});
